// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer___iVr3","signInLinkContainer":"SignUpComponent_signInLinkContainer__1IQrM"};